export interface CategoryItem {
	category: true
	/** Der angezeigte Name des Menüeintrags - Übersetzung obligatorisch */
	title: string
	permissions?: string[];
}

export interface EntryItem {
	category?: false
	/** Der angezeigte Name des Menüeintrags - Übersetzung obligatorisch */
	title: string
	key: string
	icon?: string // TODO -> auf FeatherIconsType umstellen
	url?: string
	disabled?: boolean;
	disableInProtectedPrivacy?: boolean;
	permissions?: string[];
	children?: EntryItem[],
}

export type MenuDataItem = EntryItem | CategoryItem;

export const getMenuData: MenuDataItem[] = [
	{
		title: 'misc.projects',
		key: 'projects',
		icon: 'database',
		url: '/project',
		disableInProtectedPrivacy: true,
		permissions: ['projects:read']
	},
	{
		title: 'person.user',
		key: 'user',
		icon: 'user',
		url: '/users',
		disableInProtectedPrivacy: true,
		permissions: ['users:read', 'project-users:read']
	},
	{
		title: 'person.participants',
		key: 'participant',
		icon: 'users',
		url: '/participant',
		permissions: ['participants:read'],
	},

];
